import GenericRequest, { METHOD_PUT } from '../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../shared/webservices/endpoint';

export default class AddCompanyRequest extends GenericRequest {

    // CompanySave {
    //     id: number
    //     name: string
    //     nif: string
    //     contact_person: string
    //     phone: string
    //     email: string
    //     address: string
    //     ccc: string
    //     disabled: boolean
    //     document_schema_id: number
    //     document_schema_monthly_id: number
    //     user_email: string
    //     user_password: string
    //     user_plain_password: string
    // }
    companySave;

    constructor(companySave) {
        super(METHOD_PUT, ApiEndpoints.COMPANY_ADD);
        this.companySave = companySave;
    }

    overrideRequest() {
        return this.companySave;
    }
}



// WEBPACK FOOTER //
// ./src/app/company/ws/AddCompanyRequest.js